import { Slide } from "@material-ui/core"
import { forwardRef } from "react"

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />
})

export default Transition
